module.exports = __webpack_public_path__ + "static/img/maintenance.b9a1a66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maintenance.png
// module id = 8hyu
// module chunks = 0